export default __webpack_public_path__ + "static/media/httpService.762e4e40.less";